import { Spin, Button, Card, Form, Select, Space, Table, Input, ConfigProvider, Popover, Row, Col, Typography, Pagination, message, Checkbox, Popconfirm, Tag, Divider } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile';
import { useLocation } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, SearchOutlined, QuestionCircleOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import axios from 'axios';
import './clinicianProfile.css'
import useDebounce from '../Common/useDebounce';
import AppContext from '../context/appContext';
import { Config } from '../Common/Config';

let timer;
const { Option } = Select;
const { Title } = Typography;
const options = [
  {
    label: 'English',
    value: '1',
  },
];

/** Derive initials from first name + last name */
const getInitials = (name = '', surname = '') => {
  const f = (name || '').trim()[0] || '';
  const l = (surname || '').trim()[0] || '';
  return (f + l).toUpperCase() || '?';
};

/** Teal gradient section divider with label */
const SectionDivider = ({ label }) => (
  <div className="clinician-section-divider">
    <div
      className="clinician-section-divider__line"
      style={{ background: 'linear-gradient(90deg, #c5e8e8 0%, #e0f5f5 60%, transparent 100%)' }}
    />
    <span className="clinician-section-divider__label">{label}</span>
    <div
      className="clinician-section-divider__line"
      style={{ background: 'linear-gradient(90deg, transparent 0%, #e0f5f5 40%, #c5e8e8 100%)' }}
    />
  </div>
);


const ClinicianProfile = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  // let { metaData } = useContext(AppContext)
  let showCategoryTemp = localStorage.getItem('showCategory')
   const category = location.state?.category;
   const clinic_id = location.state?.clinic_id;
  // const [productCategories, setproductCategories] = useState(showCategoryTemp ? JSON.parse(showCategoryTemp) : null);
  const [productCategoriesdataShow, setproductCategoriesdataShow] = useState([]);
  const [userDataSet, setuserDataSet] = useState({})
  const [AllClinicianData, setAllClinicianData] = useState([])
  const [AllLanguagesData, setAllLanguagesData] = useState([])
  const [loader, setloader] = useState(false)
  const [languageData, setlanguageData] = useState([])//options
  const [productsData, setproductsData] = useState(null)
  const [inputLanguage, setinputLanguage] = useState("")
  const [showLanguageInputBox, setshowLanguageInputBox] = useState(false)
  const [CurrentPage, setCurrentPage] = useState(1)
  const [isUserCreateEnable, setisUserCreateEnable] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const [inputSearchValue, setinputSearchValue] = useState('');
  const debouncedInputValue = useDebounce(inputSearchValue, 800);
  const [showAddButton, setshowAddButton] = useState(true)
  const [languages, setlanguages] = useState([])
  const [showClinicianTypeById, setshowClinicianTypeById] = useState({})
  const [Allcategory,setAllcategory] = useState(null)
  const [metaData, setmetaData] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formMode, setFormMode] = useState('edit')
  const isViewMode = formMode === 'view'

  let userTempData = localStorage.getItem('userData'), userData = {}
  if (userTempData) {
      userData = JSON.parse(userTempData)
  }
  const userRole = userData?.roles?.[0]?.role_id;
  const isCSRandCSR_R = userRole === 2 || userRole === 3;

  const hasFetched = useRef(false);
  // console.log("metaData",metaData)
     useEffect(() => {
      const fetchAll = async () => {
        await getAllMetaData()
        await getAllProductData(1)
      };
      fetchAll();
    }, []);
  useEffect(() => {
    if (!hasFetched.current) {
      getAllClinicianData(CurrentPage)
      getAllLanguages()
      hasFetched.current = true;
    }
  }, [CurrentPage])

  useEffect(() => {
    if (debouncedInputValue) {
      getAllClinicianData(1, debouncedInputValue);
    }
  }, [debouncedInputValue]);
  useEffect(() => {
    // let allProduct = [{
    //   label: 'All GP consultations',
    //   value: '0',

    // }]
    {/* productsData  Products*/ }
    // if (showCategoryTemp) {
    //   let showCategoryTempData = JSON.parse(showCategoryTemp), productCategoriesdataShowTemp = []
    //   if (showCategoryTempData && Object.values(showCategoryTempData) && Object.values(showCategoryTempData).length) {
    //     // console.log('showCategoryTempData', showCategoryTempData)
    //     Object.values(showCategoryTempData)?.map(data => {
    //       productCategoriesdataShowTemp.push({
    //         label: `${data.name}`,
    //         value: `${data.product_category_id}`,
    //       })
    //     })
    //   }
    //   setproductCategoriesdataShow(productCategoriesdataShowTemp)
    //   // console.log('productCategoriesdataShowTemp::', productCategoriesdataShowTemp)
    // }
    let allProduct = [], ClinicianTypeById = {}
    if (metaData && metaData && metaData.length > 0) {
      metaData.map(cat => {
        allProduct.push({
          label: cat.meta_value,
          value: cat.meta_id,
        })
        ClinicianTypeById[`${cat.meta_id}`] = cat.meta_value

      })
      // console.log('allProduct::', allProduct)
      setshowClinicianTypeById(ClinicianTypeById)
      setproductsData(allProduct)
    } else {
      setproductsData(allProduct)
    }
  }, [metaData]);

  const getAllProductData = async (CurrentPage, searchValue = null) => {
    if (!CurrentPage) return;
    if (!localStorage.getItem('token')) return;
    try {
      // Fetch ALL categories in one shot — no pagination truncation
      const url = `${Config.url}product-category/page/1?per_page=-1`;
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const rawList = response?.data?.data?.data;
      if (rawList && rawList.length) {
        // Accept every category — no hardcoded ID filter
        const category = {};
        rawList.forEach(cat => {
          if (cat?.product_category_id) {
            category[`category${cat.product_category_id}`] = cat;
          }
        });

        if (Object.keys(category).length) {
          setAllcategory(category);

          const productCategoriesdataShowTemp = Object.values(category).map(data => ({
            label: `${data.name}`,
            value: `${data.product_category_id}`,
          }));

          setproductCategoriesdataShow(productCategoriesdataShowTemp);
          setloader(false);
          // NOTE: do NOT overwrite localStorage.showCategory here —
          // MainRouter owns that key so the sidebar is never broken.
        }
      }
    } catch (error) {
      console.log('error in product-category ::::', error);
    }
  }
   const getAllMetaData = async () => {
  if (!localStorage.getItem('token')) return;
  try {
    const response = await axios.get(`${Config.urlLogin}/api/v1/meta-data`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      params: { category: "clinician_type" }
    });
    if (response?.data?.data && response?.data?.data.data) {
      setmetaData(response?.data?.data.data);
    }
  } catch (error) {
    console.log('error in get clinic data ::::', error)
  }
};
  // console.log("category",productCategoriesdataShow)
  const getAllClinicianData = async (CurrentPage, searchValue = null) => {
    if (!CurrentPage) {
      return
    }
    setloader(true)
    try {
      let url = `${Config.url}clinician/page/${CurrentPage}`
      if (searchValue) {
        url = `${Config.url}clinicians/search/page/${CurrentPage}?name=${searchValue}`
      }
      if(category && clinic_id){
        url = `${Config.url}clinicians/search/page/${CurrentPage}?gender=null`
      }
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setloader(false)
      setAllClinicianData(response?.data?.data)
      hasFetched.current = false;
    } catch (error) {
      console.log('error in clinician ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
    // setloader(false)
  }
  const getAllLanguages = async () => {

    try {
      let url = `${Config.url}languages`

      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log('response languages ::::', response.data.data.data)
      let languageData = [], objbyid = {}
      if (response && response.data && response.data.data && response.data.data.data) {
        response.data.data.data.map(lan => {
          languageData.push({
            label: lan.language_name,
            value: lan.language_id,
          })
          objbyid[lan.language_id] = lan.language_name
        })
        setAllLanguagesData(objbyid)
        setlanguageData(languageData)
      }
    } catch (error) {
      console.log('error in getAllLanguages ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
    // setloader(false)
  }
  const addNewLanguage = async (data) => {
    // console.log('::data::',data)
    setinputLanguage(null)
    setshowLanguageInputBox(false)
    // return
    if (!data) {
      return
    }
    let payload = {
      "language_name": data
    }
    try {
      const response = await axios.post(`${Config.url}languages`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setinputLanguage(null)
      setshowLanguageInputBox(false)
      getAllLanguages()
      messageApi.success({
        type: 'succes',
        content: 'Language added successfully',
      });
    } catch (error) {
      setinputLanguage(null)
      setshowLanguageInputBox(false)
      if (error.response && error.response.data && error.response.data.errors && Object.values(error.response.data.errors).length > 0) {
        Object.values(error.response.data.errors).map((key) => {
          messageApi.error({
            type: 'error',
            content: key ?? 'Something Went wrong',//error.response?.data || error.message ||
          });
          console.log('create user:', Object.keys(error.response.data.errors));
        })
      } else if (error.message) {
        messageApi.error({
          type: 'error',
          content: error.message ?? 'Something Went wrong',
        });

      }
    }
  }


  const onFinish = async (values, update = false) => {
    // console.log('::values::::', values)
    if (values && values.clinician_type && values.clinician_type?.value) {
      values.clinician_type = values.clinician_type?.value
    }
    // return
    setIsSubmitting(true)
    if (!update) {
      try {
        const response = await axios.post(`${Config.url}clinician`, {
          ...values
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        messageApi.success({
          type: 'succes',
          content: 'Clinician Created successfully',
        });
        setuserDataSet({})
        form.setFieldsValue({
          "name": '',
          "surname": '',
          "email": '',
          "lantum_id": '',
          "gender": '',
          "languages": [],
          "product_category": [],
          'clinician_type': []
        });
        setloader(false)
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setIsSubmitting(false)
        getAllClinicianData(CurrentPage)
      } catch (error) {
        messageApi.error({
          type: 'error',
          content: 'Something Went wrong',
        });
        console.log('create user:', error.response?.data || error.message);
        setIsSubmitting(false);
      }

    } else {
      if (!Object.keys(userDataSet).length && !userDataSet.user_id) {
        return
      }
      let url = `${Config.url}clinician/${userDataSet.id}`
      try {
        const response = await axios.put(url, {
          ...values
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        setuserDataSet({})
        form.setFieldsValue({
          "name": '',
          "surname": '',
          "email": '',
          "lantum_id": '',
          "gender": '',
          "languages": [],
          "product_category": [],
          'clinician_type': []
        });
        messageApi.success({
          type: 'succes',
          content: 'Clinician Updated successfully',
        });
        // setloader(false)
        getAllClinicianData(CurrentPage)
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setIsSubmitting(false)
      } catch (error) {
        messageApi.error({
          type: 'error',
          content: error.response?.data?.message || error.message || 'Something Went wrong',
        });
        console.log('update user:', error.response?.data, error.message);
        setIsSubmitting(false);
      }
      // console.log("Form values: false", values);
    }
    setFormMode('edit')
    setloader(false)
    setIsSubmitting(false)
  };
  const columns = [
    {
      title: 'First Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Last Name',
      dataIndex: 'surname',
      key: 'surname',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150,
    },
    {
      title: '',
      key: 'action',
      width: 48,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
          <Popover
            placement="left"
            trigger="click"
            content={() => content(record)}
            overlayInnerStyle={{ padding: '6px 0', minWidth: 140 }}
          >
            <button
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: 6,
                color: '#008385',
                fontSize: 16,
                fontWeight: 700,
                lineHeight: 1,
                letterSpacing: 2,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              title="Actions"
            >
              ···
            </button>
          </Popover>
        </div>
      ),
    },
  ];


  const actionItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    color: '#008385',
    transition: 'background 0.15s',
    userSelect: 'none',
    textDecoration: 'none',
  };

  const content = (record) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* View */}
      <a
        style={actionItemStyle}
        onClick={(e) => { e.stopPropagation(); openRecord(record, false); }}
        onMouseEnter={e => e.currentTarget.style.background = '#f0fafa'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
      >
        <EyeOutlined style={{ fontSize: 15 }} />
        View
      </a>

      {/* Edit */}
      {!isCSRandCSR_R && (
        <a
          style={actionItemStyle}
          onClick={(e) => { e.stopPropagation(); openRecord(record, true); }}
          onMouseEnter={e => e.currentTarget.style.background = '#f0fafa'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <EditOutlined style={{ fontSize: 15 }} />
          Edit
        </a>
      )}

      {/* Divider */}
      {!isCSRandCSR_R && <div style={{ height: 1, background: '#f0f0f0', margin: '2px 0' }} />}

      {/* Delete */}
      {!isCSRandCSR_R && (
        <Popconfirm
          title="Delete Clinician"
          description="Are you sure you want to permanently delete this clinician?"
          onConfirm={() => deleteUser(record)}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          okButtonProps={{ className: 'confirmation-popup-ok-button' }}
          cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
          okText="Yes, Delete"
          cancelText="Cancel"
          placement="left"
        >
          <a
            style={{ ...actionItemStyle, color: '#ff4d4f' }}
            onMouseEnter={e => e.currentTarget.style.background = '#fff1f0'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            onClick={(e) => e.stopPropagation()}
          >
            <DeleteOutlined style={{ fontSize: 15 }} />
            Delete
          </a>
        </Popconfirm>
      )}
    </div>
  );
  const deleteUser = async (record) => {
    let url = `${Config.url}clinician/${record.id}`
    try {
      const response = await axios.delete(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      messageApi.success({
        type: 'success',
        content: 'Clinician deleted successfully',
      });
      getAllClinicianData(CurrentPage)
    } catch (error) {
      console.log('deleteUser:', error.response?.data || error.message);
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || 'Something went wrong',
      });
    }
  }

  const openRecord = (record, editMode = false) => {
    setloader(true)
    setshowAddButton(false)
    setisUserCreateEnable(true)
    setFormMode(!editMode ? 'view' : 'edit')
    const copy = { ...record }
    copy.product_category = record.products?.map(a => a.toString())
    copy.clinician_type = record.clinician_type ? Number(record.clinician_type) : null
    setuserDataSet(copy)
    form.setFieldsValue(copy)
    setloader(false)
    document.querySelector(".clinicianCreate-form")?.scrollIntoView({ behavior: "smooth" });
  }

  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a style={{ color: '#4A4A4A' }}>Previous</a>;
    }
    if (type === 'next') {
      return <a style={{ color: '#4A4A4A' }}>Next</a>;
    }
    return originalElement;
  };


  let Products = [
    {
      label: 'All GP consultations',
      value: 'all_gp_consultations',

    },
    {
      label: 'Health Screen Nurse',
      value: '2',
    },
    {
      label: 'Health Screen Doctor',
      value: '1',
    }
  ];


  const showLanguageInput = () => {
    setshowLanguageInputBox(true)
  }
  // const handleSearch = (e) => {
  //   if (e.target.value != '') {
  //     setinputSearchValue(e.target.value)
  //   } else {
  //     getAllClinicianData(CurrentPage)
  //   }
  // }
  const handleSearch = (e) => {
    const value = e.target.value;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (value !== '') {
        setinputSearchValue(value);
      } else {
        getAllClinicianData(CurrentPage);
      }
    }, 500);
  };
  const clearCancelForm = () => {
    form.setFieldsValue({
      "name": '',
      "surname": '',
      "email": '',
      "lantum_id": '',
      "gender": '',
      "languages": [],
      "products": [],
      clinician_type: ''
    });
    setFormMode('edit')
    setshowAddButton(true)
    setisUserCreateEnable(false)
  }
  const setallLanguagecheck = (e) => {
    let value = e.target.value
    if (!languages.includes(value)) {
      setlanguages(pre => ([...pre, value]))
    } else {
      const filteredItems = languages.filter(item => item.id != value);
      setlanguages(filteredItems)
    }
  }
  let datacheckbox = [{
    label: 'GP appointments',
    value: '1'
  },
  {
    label: 'Health Screen',
    value: '2'
  }
  ]
  return (
    <App>
      {contextHolder}
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
          <div style={{ display: "flex", justifyContent: 'space-around', alignItems: "center", marginBottom: "10px", marginInline: 20 }}>
            <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20,marginTop: '15px',alignItems: 'end',lineHeight:'1', textAlign: 'left' }}>
              All clinicians <span style={{ color: "black", fontWeight: '400' }}>({AllClinicianData?.total ? AllClinicianData?.total : '00'})</span>
            </Title>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {(category && clinic_id) && (
              <button style={{
                border: '2px solid #008385',
                borderRadius: 8,
                background: 'none',
                color: '#555',
                padding: '10px 32px',
                fontSize: 18,
                marginRight: 16,
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontWeight: 400,
                boxSizing: 'border-box',
              }}>
                Filter "No gender"
              </button>
            )}
            <Input
              placeholder="Search for a clinician"
              prefix={<SearchOutlined />}
              allowClear
              onChange={handleSearch}
              style={{ width: 300, height: 45, borderColor: '#008385' }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Card
            style={{ width: 937, margin: 0, padding: 0, borderRadius: 40, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
          >
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBg: "#008385",
                    headerColor: "#ffffff",
                  },
                  Spin: {
                    colorPrimary: "#008385", // Change this to your desired color
                  },
                },
              }}
            >
              {AllClinicianData && <Table
                loading={loader}
                columns={columns}
                dataSource={AllClinicianData?.data}
                pagination={false}
                scroll={{
                  x: 'auto',
                  y: '350px',
                }}
                onRow={(record) => ({
                  onClick: () => openRecord(record, false),
                })}
                style={{ height: '440px' }}
              />}
              {AllClinicianData && AllClinicianData?.total ? <Pagination
                align="center"
                defaultCurrent={1}
                defaultPageSize={20}
                total={AllClinicianData?.total ? AllClinicianData?.total : undefined}
                style={{ marginTop: 10 }}
                onChange={(val, filter) => {
                  setCurrentPage(val)
                }}
                itemRender={itemRender}
              /> : ''}
            </ConfigProvider>
          </Card>
        </div>
      </div>
      <div className='button-add-left' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
        {showAddButton && !isCSRandCSR_R && (
          <Button
            type="default"
            className='add-generic-btn'
            style={{ borderColor: '#008385' }}
            onClick={() => setisUserCreateEnable(true)}
          >
            Add a clinician
          </Button>
        )}
      </div>
      <div className='clinicianCreate-form' style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginTop: 20, justifyContent: "center" }}>
        {loader === false && isUserCreateEnable && (() => {
          /* ── Derived view-mode values ── */
          const initials = getInitials(userDataSet?.name, userDataSet?.surname);
          const fullName = [userDataSet?.name, userDataSet?.surname].filter(Boolean).join(' ') || '-';

          const resolvedLanguages = (userDataSet?.languages || []).map(
            id => languageData.find(l => l.value === id)?.label || id
          );
          const resolvedProducts = (userDataSet?.product_category || []).map(
            val => productCategoriesdataShow.find(p => p.value === val)?.label || val
          );
          const resolvedClinicianType = productsData?.find(
            p => String(p.value) === String(userDataSet?.clinician_type)
          )?.label || null;

          return (
            <Card
              className={isViewMode ? 'clinician-view-mode-card' : ''}
              style={{
                width: 705,
                margin: '0',
                marginTop: 20,
                borderRadius: 16,
                boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                overflow: 'hidden',
              }}
              title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {/* Initials avatar */}
                  <div style={{
                    width: 38, height: 38, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0,
                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                  }}>
                    {isViewMode ? initials : '+'}
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                    {isViewMode ? fullName : 'Clinician Details'}
                  </span>
                </div>
              }
              extra={null}
            >
              {userDataSet && loader === false && (
                <Form
                  form={form}
                  layout="vertical"
                  initialValues={userDataSet || null}
                  onFinish={(values) => onFinish(values, Object.keys(userDataSet).length ? true : false)}
                >
                  {/* ═══════════════════════════════════════════════════════
                      VIEW MODE
                  ═══════════════════════════════════════════════════════ */}
                  {isViewMode ? (
                    <div style={{ padding: '0 4px' }}>

                      {/* ── Personal Information ── */}
                      <SectionDivider label="Personal Information" />
                      <div className="clinician-view-detail-row">
                        <label>First Name</label>
                        <span className="clinician-view-field-value">{userDataSet?.name || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Last Name</label>
                        <span className="clinician-view-field-value">{userDataSet?.surname || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Email</label>
                        <span className="clinician-view-field-value">{userDataSet?.email || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Gender</label>
                        {userDataSet?.gender
                          ? <Tag className="clinician-tag-pill" style={{ textTransform: 'capitalize' }}>{userDataSet.gender}</Tag>
                          : <span className="clinician-view-field-value">-</span>
                        }
                      </div>

                      {/* ── Professional Details ── */}
                      <SectionDivider label="Professional Details" />
                      <div className="clinician-view-detail-row">
                        <label>Lantum ID</label>
                        <span className="clinician-view-field-value">{userDataSet?.lantum_id || '-'}</span>
                      </div>
                      <div className="clinician-view-detail-row">
                        <label>Clinician Type</label>
                        {resolvedClinicianType
                          ? <Tag className="clinician-tag-pill">{resolvedClinicianType}</Tag>
                          : <span className="clinician-view-field-value">-</span>
                        }
                      </div>

                      {/* ── Languages ── */}
                      <SectionDivider label="Languages" />
                      <div style={{ padding: '6px 2px 10px' }}>
                        {resolvedLanguages.length > 0 ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {resolvedLanguages.map((lang, i) => (
                              <Tag key={i} className="clinician-tag-pill">{lang}</Tag>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#bbb', fontSize: 13 }}>No languages specified</span>
                        )}
                      </div>

                      {/* ── Products ── */}
                      <SectionDivider label="Products" />
                      <div style={{ padding: '6px 2px 4px' }}>
                        {resolvedProducts.length > 0 ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {resolvedProducts.map((prod, i) => (
                              <Tag key={i} className="clinician-tag-pill">{prod}</Tag>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#bbb', fontSize: 13 }}>No products assigned</span>
                        )}
                      </div>

                      {/* ── View mode bottom actions ── */}
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                        <Button
                          onClick={clearCancelForm}
                          style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                        >
                          Cancel
                        </Button>
                        {!isCSRandCSR_R && (
                          <Button
                            className="edit-btn-green"
                            icon={<EditOutlined />}
                            onClick={() => setFormMode('edit')}
                            style={{ minWidth: 100 }}
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    </div>

                  ) : (
                    /* ═══════════════════════════════════════════════════════
                        EDIT MODE — original form layout unchanged
                    ═══════════════════════════════════════════════════════ */
                    <>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item name="name" label="First Name" rules={[{ required: true, message: 'Clinician name is required.' }]}>
                            <Input placeholder="First Name" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="surname" label="Last Name">
                            <Input placeholder="Last Name" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                              { type: 'email', message: 'Invalid email format!' },
                              { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: 'Please enter a valid email address!' },
                            ]}
                          >
                            <Input autoComplete="off" placeholder="Email" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="lantum_id" label="Lantum ID" rules={[{ required: true, message: 'Lantum ID is required' }]}>
                            <Input autoComplete="off" placeholder="Lantum ID" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item name="gender" label="Gender" rules={[{ required: true, message: 'Gender selection is required.' }]}>
                            <Select placeholder="Select Gender" style={{ width: '100%' }} allowClear className='dropdown'>
                              <Option value="male">Male</Option>
                              <Option value="female">Female</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="clinician_type" label="Clinician Type" rules={[{ required: true, message: 'Clinician type selection is required.' }]}>
                            <Select placeholder="Select clinician type" allowClear>
                              {productsData?.map(clType => (
                                <Option value={clType.value} key={clType.value}>{clType.label}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      {/* Languages */}
                      <Form.Item name="languages" label="Languages" rules={[{ required: true, message: 'Languages selection is required.' }]}>
                        <Checkbox.Group>
                          {languageData && languageData.map(lan => (
                            <Checkbox value={lan.value} key={lan.value + lan.label} onChange={setallLanguagecheck}>
                              {lan.label}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Form.Item>
                      <Space.Compact style={{ width: '100%', marginBottom: 10 }}>
                        {showLanguageInputBox && (
                          <Input autoComplete="off" placeholder="Language" onChange={(e) => setinputLanguage(e.target.value)} />
                        )}
                        <Button
                          type="default"
                          className='add-generic-btn'
                          style={{ borderColor: '#008385' }}
                          onClick={() => inputLanguage ? addNewLanguage(inputLanguage) : showLanguageInput()}
                        >
                          Add a language
                        </Button>
                      </Space.Compact>

                      {/* Products */}
                      <div style={{ height: 1, background: 'linear-gradient(90deg, #c5e8e8 0%, #e0f5f5 60%, transparent 100%)', margin: '8px 0 12px', borderRadius: 2 }} />
                      <Form.Item name="product_category" label="Products" rules={[{ required: true, message: 'Product selection is required.' }]}>
                        <Checkbox.Group>
                          {productCategoriesdataShow?.map(lan => (
                            <Checkbox value={lan.value} key={lan.value}>{lan.label}</Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Form.Item>

                      {/* Edit mode action buttons — centred */}
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 16, paddingBottom: 4 }}>
                        <Button
                          onClick={clearCancelForm}
                          style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                        >
                          Cancel
                        </Button>
                        <Button
                          htmlType="submit"
                          loading={isSubmitting}
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: isSubmitting ? '#80bebe' : '#008385',
                            borderColor: isSubmitting ? '#80bebe' : '#008385',
                            color: '#fff',
                            cursor: isSubmitting ? 'not-allowed' : 'pointer',
                            minWidth: 100,
                          }}
                        >
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      </div>
                    </>
                  )}
                </Form>
              )}
            </Card>
          );
        })()}
      </div>

    </App>
  )
}

export default ClinicianProfile